/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EInvoicingSettings
 */
export interface EInvoicingSettings {
    /**
     * 
     * @type {boolean}
     * @memberof EInvoicingSettings
     */
    excludedFromAutomaticEInvoicing: boolean;
}

/**
 * Check if a given object implements the EInvoicingSettings interface.
 */
export function instanceOfEInvoicingSettings(value: object): value is EInvoicingSettings {
    if (!('excludedFromAutomaticEInvoicing' in value) || value['excludedFromAutomaticEInvoicing'] === undefined) return false;
    return true;
}

export function EInvoicingSettingsFromJSON(json: any): EInvoicingSettings {
    return EInvoicingSettingsFromJSONTyped(json, false);
}

export function EInvoicingSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EInvoicingSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'excludedFromAutomaticEInvoicing': json['excludedFromAutomaticEInvoicing'],
    };
}

export function EInvoicingSettingsToJSON(value?: EInvoicingSettings | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'excludedFromAutomaticEInvoicing': value['excludedFromAutomaticEInvoicing'],
    };
}

